import React, { Component } from "react";
import homedata from "../../data/home.json";

class OurTeams extends Component {
  render() {
    let ourTeamsContent = homedata.ourTeams;
    let sectionHeadingInfo = ourTeamsContent.sectionHeading;
    let workContent = ourTeamsContent.workProcess;

    const gradients = [
      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
      "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
    ];

    return (
      <section id="tim_kami" className="modern-team-section pt100 pb100">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-md-10 col-sm-12 offset-lg-2 offset-md-1">
              <div className="section-title text-center mb60">
                <h2
                  dangerouslySetInnerHTML={{ __html: sectionHeadingInfo.title }}
                ></h2>
                <hr className="lines" />
                <p className="section-description">{sectionHeadingInfo.desc}</p>
              </div>
            </div>
          </div>

          <div className="row">
            {workContent.map((element, i) => {
              return (
                <div key={i} className="col-lg-3 col-md-6 col-sm-12 mb-4">
                  <div className="team-card">
                    <div
                      className="team-card-header"
                      style={{ background: gradients[i % gradients.length] }}
                    >
                      <div className="team-avatar">
                        <i className="pe-7s-user"></i>
                      </div>
                    </div>
                    <div className="team-card-body">
                      <h4 className="team-name">{element.name}</h4>
                      <p className="team-title">{element.title}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <style jsx="true">{`
          .modern-team-section {
            background: linear-gradient(180deg, #f8f9ff 0%, #ffffff 100%);
            position: relative;
          }

          .section-title h2 {
            font-size: 42px;
            font-weight: 700;
            color: #1a1a2e;
            margin-bottom: 15px;
          }

          .section-title h2 span {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }

          .section-description {
            font-size: 16px;
            color: #6c757d;
            line-height: 1.8;
            margin-top: 15px;
          }

          .team-card {
            background: white;
            border-radius: 20px;
            overflow: hidden;
            box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
            transition: all 0.3s ease;
            height: 100%;
          }

          .team-card:hover {
            transform: translateY(-10px);
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
          }

          .team-card-header {
            height: 180px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            overflow: hidden;
          }

          .team-card-header::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: radial-gradient(
              circle at 50% 50%,
              rgba(255, 255, 255, 0.2) 0%,
              transparent 70%
            );
          }

          .team-avatar {
            width: 100px;
            height: 100px;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.3);
            backdrop-filter: blur(10px);
            border: 3px solid white;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            z-index: 1;
          }

          .team-avatar i {
            font-size: 50px;
            color: white;
          }

          .team-card-body {
            padding: 25px 20px;
            text-align: center;
          }

          .team-name {
            font-size: 20px;
            font-weight: 700;
            color: #1a1a2e;
            margin-bottom: 8px;
          }

          .team-title {
            font-size: 14px;
            color: #6c757d;
            margin: 0;
            line-height: 1.6;
          }

          @media (max-width: 991px) {
            .section-title h2 {
              font-size: 32px;
            }

            .team-card {
              margin-bottom: 20px;
            }
          }

          @media (max-width: 767px) {
            .team-card-header {
              height: 150px;
            }

            .team-avatar {
              width: 80px;
              height: 80px;
            }

            .team-avatar i {
              font-size: 40px;
            }
          }
        `}</style>
      </section>
    );
  }
}

export default OurTeams;
